import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import {showSnackbar} from "../../api/snackbarSlice";
import { useDispatch } from 'react-redux';

import { AxiosError } from 'axios';
import {apiClient} from "../../utils/axios";

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);

    return debouncedValue;
}

const fetchNatureCodes = async (query ) => {
    const { data } = await apiClient.get(`/codelist/nature-codes?query=${query.queryKey[1]}`);
    return data;
};

export const useNatureCodeHandler = ({searchQuery} ) => {
    const dispatch = useDispatch();
    const [natureCodes, setNatureCodes] = useState([]);
    const [totalCodes, setTotalCodes] = useState(0);

    const debounceSearchQ = useDebounce(searchQuery, 2000);
    const {
        data: fetchedData,
        isLoading,
        isError,
        error,
    } = useQuery(
        {
            queryKey: ['nature code',debounceSearchQ] , // A unique key for this query
            cacheTime: 0,
            queryFn: fetchNatureCodes,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
            refetchOnMount: 'always',
        }
    );
    useEffect(() => {
        const updateData=()=>{
            if(fetchedData) {
                setNatureCodes( ()=> fetchedData.content);
                setTotalCodes(()=> fetchedData.size);
            }
        }
        updateData();

    }, [fetchedData]);

    useEffect(() => {
        if (isError) {
            if (error instanceof AxiosError) {
                if (error.status) {
                    dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
                } else {
                    dispatch(showSnackbar({ message: error.message, severity: 'error' }));
                }
            } else {
                dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
            }
        }
    }, [dispatch, error, isError]);

    return {
        natureCodes,
        totalCodes,
        isLoading,
    };
};
